<template>
  <div class="host-requests">
    <!-- فیلترها -->
    <b-card class="mb-4">
      <b-row>
        <b-col md="4">
          <b-form-group label="جستجو">
            <b-form-input
                v-model="filters.search"
                placeholder="جستجو در نام یا موبایل..."
                @input="handleSearch"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="وضعیت">
            <b-form-select
                v-model="filters.status"
                :options="statusOptions"
                @change="getHosts"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- جدول درخواست‌ها -->
    <b-card>
      <b-table
          :items="hosts.data"
          :fields="fields"
          responsive="sm"
          show-empty
          empty-text="درخواستی یافت نشد"
          :busy="isLoading"
      >
        <!-- نام کاربر -->
        <template #cell(user)="data">
          <div>
            {{ data.item.user.full_name }}
            <br>
            <small class="text-muted">{{ data.item.user.mobile }}</small>
          </div>
        </template>

        <!-- موقعیت -->
        <template #cell(location)="data">
          {{ data.item.state.name }} - {{ data.item.city.name }}
        </template>

        <!-- نوع خدمات -->
        <template #cell(service_type)="data">
          <b-badge
              v-for="service in data.item.service_type"
              :key="service"
              variant="info"
              class="mr-1"
          >
            {{ getServiceLabel(service) }}
          </b-badge>
        </template>

        <!-- وضعیت -->
        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.status)">
            {{ getStatusLabel(data.item.status) }}
          </b-badge>
        </template>

        <!-- مدارک -->
        <template #cell(upload_file)="data">
          <b-button
              size="sm"
              variant="outline-primary"
              :href="$http.defaults.fileUrl+'/storage/'+ data.item.upload_file"
              target="_blank"
          >
            مشاهده
          </b-button>
        </template>

        <!-- عملیات -->
        <template #cell(actions)="data">
          <b-button-group size="sm">
            <b-button
                variant="success"
                @click="handleApprove(data.item)"
                :disabled="data.item.status !== 'pending'"
            >
              تایید
            </b-button>
            <b-button
                variant="danger"
                @click="showRejectModal(data.item)"
                :disabled="data.item.status !== 'pending'"
            >
              رد
            </b-button>
          </b-button-group>
        </template>
      </b-table>

      <!-- صفحه‌بندی -->
      <div class="mt-3">
        <b-pagination
            v-model="page"
            :total-rows="hosts.total"
            :per-page="perPage"
            align="center"
            @change="getHosts"
        ></b-pagination>
      </div>
    </b-card>

    <!-- مودال رد درخواست -->
    <b-modal
        id="reject-modal"
        title="رد درخواست"
        ok-title="تایید"
        cancel-title="انصراف"
        @ok="handleReject"
    >
      <b-form-group
          label="دلیل رد درخواست"
          label-for="reject-reason"
      >
        <b-form-textarea
            id="reject-reason"
            v-model="rejectReason"
            rows="3"
            required
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect, BFormTextarea, BModal, BPagination,
  BRow,
  BTable
} from "bootstrap-vue";

export default {
  components: {
    BFormTextarea,
    BModal,
    BPagination,
    BButtonGroup, BButton, BBadge, BTable, BFormSelect, BFormInput, BFormGroup, BCol, BRow, BCard},
  data() {
    return {
      hosts: {
        data: [],
        total: 0
      },
      page: 1,
      perPage: 10,
      isLoading: false,
      filters: {
        search: '',
        status: null
      },
      fields: [
        { key: 'user', label: 'کاربر' },
        { key: 'location', label: 'موقعیت' },
        { key: 'service_type', label: 'نوع خدمات' },
        { key: 'status', label: 'وضعیت' },
        { key: 'upload_file', label: 'مدارک' },
        { key: 'actions', label: 'عملیات' }
      ],
      statusOptions: [
        { value: null, text: 'همه' },
        { value: 'pending', text: 'در انتظار بررسی' },
        { value: 'approved', text: 'تایید شده' },
        { value: 'rejected', text: 'رد شده' }
      ],
      selectedRequest: null,
      rejectReason: ''
    }
  },

  mounted() {
    this.getHosts()
  },

  methods: {
    // دریافت لیست درخواست‌ها
    async getHosts() {
      this.isLoading = true

      try {
        const params = {
          page: this.page,
          per_page: this.perPage,
          ...this.filters
        }

        const response = await this.$http.get('/admin/host-requests', { params })
        this.hosts = response.data
      } catch (error) {
        this.$bvToast.toast('خطا در دریافت اطلاعات', {
          title: 'خطا',
          variant: 'danger'
        })
      } finally {
        this.isLoading = false
      }
    },

    // جستجو با تاخیر
    handleSearch: debounce(function() {
      this.page = 1
      this.getHosts()
    }, 500),

    // نمایش مودال رد درخواست
    showRejectModal(request) {
      this.selectedRequest = request
      this.rejectReason = ''
      this.$bvModal.show('reject-modal')
    },

    // تایید درخواست
    async handleApprove(request) {
      try {
        await this.$http.patch(`/admin/host-requests/${request.id}/status`, {
          status: 'approved'
        })

        this.$bvToast.toast('درخواست با موفقیت تایید شد', {
          title: 'موفق',
          variant: 'success'
        })

        this.getHosts()
      } catch (error) {
        this.$bvToast.toast('خطا در تایید درخواست', {
          title: 'خطا',
          variant: 'danger'
        })
      }
    },

    // رد درخواست
    async handleReject(bvModalEvent) {
      bvModalEvent.preventDefault()

      if (!this.rejectReason) {
        this.$bvToast.toast('لطفاً دلیل رد درخواست را وارد کنید', {
          title: 'خطا',
          variant: 'danger'
        })
        return
      }

      try {
        await this.$http.patch(`/admin/host-requests/${this.selectedRequest.id}/status`, {
          status: 'rejected',
          reject_reason: this.rejectReason
        })

        this.$bvModal.hide('reject-modal')
        this.$bvToast.toast('درخواست با موفقیت رد شد', {
          title: 'موفق',
          variant: 'success'
        })

        this.getHosts()
      } catch (error) {
        this.$bvToast.toast('خطا در رد درخواست', {
          title: 'خطا',
          variant: 'danger'
        })
      }
    },

    // تبدیل کد وضعیت به متن
    getStatusLabel(status) {
      const labels = {
        pending: 'در انتظار بررسی',
        approved: 'تایید شده',
        rejected: 'رد شده'
      }
      return labels[status] || status
    },

    // تبدیل کد وضعیت به کلاس رنگ
    getStatusVariant(status) {
      const variants = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger'
      }
      return variants[status] || 'secondary'
    },

    // تبدیل کد خدمت به متن
    getServiceLabel(service) {
      const labels = {
        car: 'خودرو',
        experience: 'تجربه',
        residence: 'اقامتگاه',
        tour: 'تور'
      }
      return labels[service] || service
    }
  }
}
</script>

<style scoped>
.host-requests {
.badge {
  font-size: 90%;
}
}
</style>